import React, { useEffect, useState } from "react";
import { View, Modal, Text } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import ModalPurchase from "../../components/ModalPurchase";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ConfirmEmail from "../../components/ConfirmEmail/ConfirmEmail";
import api from "../../services/api";
import styles from "./styles";
import ModalSell from "../../components/ModalSell";
import toast from "../../utils/toast";
import { TouchableOpacity } from "react-native-gesture-handler";
import { If, Else, Then } from "react-if";
import { ActivityIndicator } from "react-native-paper";

const ConfirmPasswordPurchaseOrSell = (props) => {
  const navigation = useNavigation();
  const [password, setPassword] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [emailCode, setEmailCode] = useState();
  const [emailVerified, setEmailVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  /* useEffect(() => {
    resetPassword();
  }, [password, emailCode]); */

  const getMarketplaceToken = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    console.log(props.route.params.valueToken);

    var data = {
      qtd: props.route.params.qtd,
      id_coin: props.route.params.token,
      valueToken: props.route.params.valueToken,
      password: password,
      isBuy: props.route.params.purchase,
    };
    console.log("data.valueToken", data.valueToken);
    try {
      await api.post("marketplace-moviments", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalVisible(!modalVisible);
    } catch (error) {
      if (error.response?.data?.message) {
        toast(error.response?.data?.message, "#DA1414");
      }
      throw error;
    }
  };

  const getExchangeToken = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    var data = {
      quantity: props.route.params.qtd,
      id_token: props.route.params.token,
      value: props.route.params.valueToken, //props.route.params.market === false ? props.route.params.valueToken : null,
      is_purchase: props.route.params.purchase,
      password: password,
    };

    try {
      await api.post("exchange-order", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalVisible(!modalVisible);
    } catch (error) {
      if (error.response?.data?.message) {
        toast(error.response?.data?.message, "#DA1414");
      }
      console.log(error);
      throw error;
    }
  };

  const handleConfirmation = async () => {
    setLoading(true);
    try {
      if (
        password.length === 6 &&
        !props.route.params?.market &&
        emailVerified === true
      ) {
        await getMarketplaceToken();
      } else if (password.length === 6 && emailVerified === true) {
        await getExchangeToken();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FormattedMessage id="confPsswdPuOrSell.headerConfirmaSenha">
        {(header) => <HeaderTabs title={header} />}
      </FormattedMessage>

      <View style={styles.container}>
        <View style={styles.card}>
          <Text style={styles.cardTitle}>
            <If condition={props.route.params.purchase}>
              <Then>
                <FormattedMessage id="confPsswdPuOrSell.confirmacaoCompra" />
              </Then>
              <Else>
                <FormattedMessage id="confPsswdPuOrSell.confirmacaoVenda" />
              </Else>
            </If>
          </Text>
          <View style={styles.cardPassword}>
            <FormattedMessage id="confPsswdPuOrSell.lblDigiteSenha">
              {(label) => (
                <AuthCodeInput
                  cellCount={6}
                  isPassword={true}
                  value={password}
                  onValueChange={(value) => setPassword(value)}
                  label={label}
                />
              )}
            </FormattedMessage>
          </View>
          <View style={styles.cardFooter}>
            <View>
              <TouchableOpacity
                style={styles.button1}
                onPress={() => navigation.goBack()}
              >
                <Text style={styles.buttonText1}>
                  <FormattedMessage id="withdrawgpxpassword.cancelar" />
                </Text>
              </TouchableOpacity>
            </View>
            <View>
              <TouchableOpacity
                style={styles.button2}
                onPress={() => {
                  handleConfirmation();
                }}
              >
                <Text style={styles.buttonText2}>
                  <FormattedMessage id="confirmSell.confirma" />
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          <ConfirmEmail
            onChange={(value) => setEmailCode(value)}
            onVerified={(value) => setEmailVerified(value)}
          />
        </View>
        <Modal
          animationType="fade"
          transparent={false}
          visible={modalVisible}
          statusBarTranslucent={true}
          onRequestClose={() => navigation.navigate("Tabs")}
        >
          <If condition={props.route.params.purchase}>
            <Then>
              <ModalPurchase
                handleCloseModal={() => {
                  setModalVisible(false);
                  navigation.navigate("Home");
                }}
                handleCloseWithTransaction={() => {
                  setModalVisible(false);
                  console.log(">>>>>>", props.route.params);
                  navigation.navigate({
                    name: "Home",
                    params: {
                      openTransaction: true,
                      id: props.route.params.token,
                      name_token: props.route.params.name_token,
                      name: props.route.params.name_token,
                      path: props.route.params.path,
                      single_value: props.route.params.single_value,
                      cryptoactive: props.route.params.cryptoactive,
                    },
                  });
                }}
                showTransactionSlip={
                  props.route.params.purchase && !props.route.params?.market
                }
              />
            </Then>
          </If>
          <If condition={!props.route.params.purchase}>
            <Then>
              <ModalSell
                handleCloseModal={() => {
                  setModalVisible(false);
                  navigation.navigate({
                    name: "Home",
                    params: {
                      id: props.route.params.token,
                      name_token: props.route.params.name_token,
                      path: props.route.params.path,
                      single_value: props.route.params.single_value,
                      cryptoactive: props.route.params.cryptoactive,
                    },
                  });
                }}
              />
            </Then>
          </If>
        </Modal>
      </View>
      <If condition={loading}>
        <Then>
          <View style={styles.loadingOverlay}>
            <ActivityIndicator size="large" color="#077A97" />
          </View>
        </Then>
      </If>
    </>
  );
};

export default ConfirmPasswordPurchaseOrSell;
